"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowForward = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ArrowForward = function ArrowForward(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.194 5.29628L19.2037 11.306C19.3933 11.494 19.5 11.7501 19.5 12.0171C19.5 12.2842 19.3933 12.5402 19.2037 12.7283L13.194 18.738C12.8013 19.128 12.1667 19.1257 11.7767 18.733C11.3867 18.3402 11.389 17.7057 11.7817 17.3157L16.0987 13.0187L5.50162 13.0187C4.94844 13.0187 4.5 12.5703 4.5 12.0171C4.5 11.4639 4.94844 11.0155 5.50162 11.0155L16.0987 11.0155L11.7817 6.71857C11.5906 6.5312 11.4824 6.2751 11.4813 6.00742C11.4797 5.74119 11.5842 5.4853 11.7717 5.29628C11.9598 5.10666 12.2158 5 12.4829 5C12.7499 5 13.006 5.10666 13.194 5.29628Z"
  }));
};

exports.ArrowForward = ArrowForward;